export default __webpack_public_path__ + "static/media/Residential-building.7c62d967.jpg";